<div class="cart-coupon-applied">
  <rrs-coupon-tag
    *ngFor="let voucher of sortedVouchers"
    (closeTag)="removeVoucher(voucher.voucherCode)"
    [closeable]="!isReadOnly"
    [disabled]="cartIsLoading"
    [label]="voucher.voucherCode"
    class="my-3"></rrs-coupon-tag>
</div>
